import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqData = [
        {
            question: "How does Existence Media help brands and content creators?",
            answer: "We help brands and creators grow through content creation, viral optimization, and social media strategies to boost engagement and reach.",
        },
        {
            question: "Can I work with you even though I have a small audience base?",
            answer: "Yes! We work with creators of all sizes and help you grow, no matter your starting point.",
        },
        {
            question: "I have never posted on social media before. How do I start?",
            answer: "No problem! We guide you through content creation, optimization, and audience engagement to help you launch successfully.",
        },
        {
            question: "Can you connect me with influencers?",
            answer: "Yes, we have access to a network of influencers across various niches who can help amplify your brand.",
        },
        {
            question: "How do I get started?",
            answer: "Just contact us! We’ll discuss your goals and create a custom strategy that fits your needs.",
        },
    ];
    

    return (
        <div className="faq-container">
            <h1 className="faq-title">Frequently Asked Questions</h1>
            <div className="faq-list">
                {faqData.map((faq, index) => (
                    <div
                        key={index}
                        className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="faq-question">
                            {faq.question}
                            <span className="faq-icon">
                                {activeIndex === index ? '-' : '+'}
                            </span>
                        </div>
                        <div className="faq-answer">
                            <p>{faq.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;
